import React from 'react';

interface FilterChipProps {
  label: string;
  onClear: () => void;
}

export function FilterChip({ label, onClear }: FilterChipProps) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-theme-cards border border-theme-primary/50 px-3 py-1 text-xs font-medium text-white">
      {label}
      <button
        onClick={onClear}
        aria-label={`Remove ${label}`}
        className="opacity-70 hover:opacity-100 transition-opacity ml-0.5"
      >
        ✕
      </button>
    </span>
  );
}
